<template>
  <div>
    <data-table
      api-route="/municipios/"
      item-key="codmunicipioibge"
      :columns="columns"
      :filters="filters"
      sort-by="nome_municipio"
    />
    <FloatBtn text="Cadastrar Município" :to="{ name: 'cadastro-municipio' }" />
  </div>
</template>

<script>
import DataTable from './comum/DataTable.vue';
import FloatBtn from './FloatBtn.vue';

export default {
  components: {
    DataTable,
    FloatBtn,
  },
  data() {
    return {
      columns: [
        { key: 'codmunicipioibge', title: 'Código IBGE' },
        { key: 'nome_municipio', title: 'Município' },
        { key: 'latitude', title: 'Latitude' },
        { key: 'longitude', title: 'Longitude' },
        { key: 'cod_uf', title: 'UF' },
        { key: 'sigla_uf', title: 'Sigla UF' },
      ],
      filters: [
        { model: 'nome', itemKey: 'nome_municipio', label: 'Filtrar por nome', icon: 'mdi-magnify' },
        { model: 'codmunicipio', itemKey: 'codmunicipioibge', label: 'Filtrar por Código IBGE', type: 'number', icon: 'mdi-numeric' },
      ],
    };
  },
};
</script>
